import { colors } from 'theme'

export const defaultThemeStyles = {
    modalFormText: colors.darkCloud
}
